module.exports = __webpack_public_path__ + "static/img/doctor.8139f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor.png
// module id = zoJu
// module chunks = 1